import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Input from 'components/common/Input';
import { contextPayment } from 'context';
import { convertToNumber, currency, noCurrency } from 'helpers/utils';

const PaymentTotals = ({ handleSubmit, onSubmitData, onError, watch, register, setValue, errors }) => {
 const { contract } = contextPayment();
 const [formData, setFormData] = useState({ paid: '', acceptance: false });

 const handleChange = ({ target: { type, name, checked, value } }) => {
  if (type === 'checkbox') return setFormData({ ...formData, [name]: checked });
  const mount = noCurrency(value);
  setValue('amount_in_cents', convertToNumber((mount || contract?.owed) * 100));
  setValue('amount', convertToNumber(mount || contract?.owed));
  setFormData({ ...formData, [name]: mount ? currency(value, true) : '' });
 };

 useEffect(() => {
  setValue('amount_in_cents', convertToNumber(contract?.owed * 100));
  setValue('amount', convertToNumber(contract?.owed));
 }, [contract]);

 return (
  <>
   <Flex className="fs--1 mb-1" justifyContent="between">
    <p className="mb-0">Monto de cuota</p>
    <span>{currency(contract?.owed, true)}</span>
   </Flex>
   <Flex className="fs--1 mb-1 text-success" justifyContent="between">
    <p className="mb-0">Saldo a la fecha</p>
    <span>{currency(convertToNumber(contract?.amount - contract?.paid), true)}</span>
   </Flex>
   <hr />
   <Input
    type="text"
    errors={errors['amount_in_cents'] ? { ...errors, paid: errors['amount_in_cents'] } : errors}
    label="Abono"
    name="paid"
    placeholder={'Abono ' + currency(contract?.owed, true)}
    formLabelProps={{ column: true, xs: 4, className: 'fs--1' }}
    formColumnProps={{ xs: 8, className: 'text-info' }}
    formGroupProps={{ as: Row, className: 'mb-3' }}
    formControlProps={{
     name: 'paid',
     value: formData.paid,
     maxLength: 30,
     autoComplete: 'off',
     className: 'fs--1 text-end',
     onChange: handleChange
    }}
   />
   <Form.Control
    type="hidden"
    {...register('amount_in_cents', {
     required: true,
     validate: value => value > 10000 || 'El abono debe ser mayor de $ 100 o vacio'
    })}
   />
   <hr className="my-3 my-md-4" />
   <h5 className="d-flex justify-content-between">
    <span>Total a pagar</span>
    <span>{currency(convertToNumber(watch('amount_in_cents') / 100), true)}</span>
   </h5>
   <p className="fs--1 text-600">
    Una vez se concluya su solicitud, recibirá un correo electrónico con el estado de su transacción.
   </p>
   {/* <p className="fs--1 text-600">
    Once you start your trial, you will have 30 days to use Falcon Premium for free. After 30 days you’ll be charged based on your
    selected plan.
   </p> */}
   <hr className="my-3 my-md-4" />

   <Input
    type="checkbox"
    //errors={errors}
    label={
     <>
      Acepto haber leído los{' '}
      <Link to={watch('permalink')} target="_blank">
       términos y condiciones y la política de privacidad
      </Link>{' '}
      para hacer este pago
     </>
    }
    name="acceptance"
    formLabelProps={{ className: 'text-700', bsPrefix: 'fs--2' }}
    formGroupProps={{ className: 'mb-0' }}
    formControlProps={{ className: 'mt-2', name: 'acceptance', checked: formData.acceptance, onChange: handleChange }}
   />
   <Button
    variant="primary"
    type="submit"
    className="d-block w-100"
    disabled={!formData.acceptance}
    onClick={() => handleSubmit(onSubmitData, onError)()}
   >
    <FontAwesomeIcon icon="exchange-alt" className="me-2" />
    Transferir
   </Button>
   <div className="text-center mt-2">
    <small className="d-inline-block">
     ¿Necesita ayuda? Contáctenos en <Link to="tel:+1-888-123-4567">+1-888-123-4567</Link> o{' '}
     <Link to="mailto:correo_ejemplo@example.com">correo_ejemplo@example.com</Link>.
    </small>
    {/* <small className="d-inline-block">
     By continuing, you are agreeing to our subscriber <Link to="#!">terms</Link> and will be charged at the end of the trial.
    </small> */}
   </div>
  </>
 );
};

PaymentTotals.propTypes = {
 watch: PropTypes.func,
 register: PropTypes.func,
 setValue: PropTypes.func,
 errors: PropTypes.object,
 handleSubmit: PropTypes.func,
 onSubmitData: PropTypes.func,
 onError: PropTypes.func
};

export default PaymentTotals;
